import { atom } from "recoil";

const contentLoading = atom({
    key: 'content-loading',
    default: false,
});

const contentSelected = atom({
    key: 'content-selected',
    default: '',
});

const contentOptions = atom({
    key: 'content-options',
    default: [],
});

const contentCurrentPage = atom({
    key: 'content-current-page',
    default: 1,
});

const contentData = atom({
    key: 'content-data',
    default: {},
});

const contentDetail = atom({
    key: 'content-detail',
    default: {
        id: '',
        date: '',
        cover: '',
        title: '',
        description: '',
        topic: '',
        documents: [],
        videos: [],
        quizzes: [],
    },
});

const contentInput = atom({
    key: 'content-input',
    default: {
        cover: null,
        title: '',
        description: '',
        topic: '',
        documents: [],
        videos: [],
        quizzes: [],
    },
});

const contentMessage = atom({
    key: 'content-message',
    default: {}
});

const contentDeleted = atom({
    key: 'content-deleted',
    default: false
});

export {
    contentLoading, 
    contentSelected, 
    contentOptions,
    contentCurrentPage,
    contentData,
    contentDetail,
    contentInput,
    contentMessage,
    contentDeleted,
};